if (!customElements.get('urgency-countdown')) {
  customElements.define(
    'urgency-countdown',
    class UrgencyCountdown extends HTMLElement {
      connectedCallback() {
        this.daysEl = this.querySelector('[data-value="days"]');
        this.hoursEl = this.querySelector('[data-value="hours"]');
        this.minutesEl = this.querySelector('[data-value="minutes"]');
        this.secondsEl = this.querySelector('[data-value="seconds"]');
        this.daysBox = this.querySelector('[data-unit="days"]');

        this.endTime = this.getEndTime();

        if (!this.endTime) return;

        this.tick();
        this.interval = window.setInterval(this.tick.bind(this), 1000);
      }

      disconnectedCallback() {
        if (this.interval) window.clearInterval(this.interval);
      }

      getEndTime() {
        const type = this.dataset.timerType;

        if (type === 'fixed') {
          const parsed = new Date(this.dataset.endDate);
          return isNaN(parsed.getTime()) ? null : parsed.getTime();
        }

        // Evergreen: persist a per-visitor end time so the countdown feels continuous
        // across page views, then resets once it expires.
        const storageKey = this.dataset.storageKey;
        const durationMs = (parseFloat(this.dataset.durationHours) || 24) * 60 * 60 * 1000;

        try {
          const stored = window.localStorage.getItem(storageKey);
          const now = Date.now();

          if (stored && parseInt(stored, 10) > now) {
            return parseInt(stored, 10);
          }

          const newEnd = now + durationMs;
          window.localStorage.setItem(storageKey, String(newEnd));
          return newEnd;
        } catch (error) {
          // localStorage unavailable (e.g. private mode) — fall back to a session-only timer.
          return Date.now() + durationMs;
        }
      }

      tick() {
        const remaining = this.endTime - Date.now();

        if (remaining <= 0) {
          this.handleExpired();
          return;
        }

        const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((remaining / (1000 * 60)) % 60);
        const seconds = Math.floor((remaining / 1000) % 60);

        if (this.daysBox) this.daysBox.style.display = days > 0 ? '' : 'none';
        this.setValue(this.daysEl, days);
        this.setValue(this.hoursEl, hours);
        this.setValue(this.minutesEl, minutes);
        this.setValue(this.secondsEl, seconds);
      }

      setValue(el, value) {
        if (el) el.textContent = String(value).padStart(2, '0');
      }

      handleExpired() {
        if (this.interval) window.clearInterval(this.interval);
        this.classList.add('is-expired');

        if (this.dataset.timerType === 'evergreen') {
          try {
            window.localStorage.removeItem(this.dataset.storageKey);
          } catch (error) {
            /* no-op */
          }
        }

        const expiredText = this.dataset.expiredText;
        if (expiredText) {
          const label = document.createElement('p');
          label.className = 'urgency-countdown__expired';
          label.textContent = expiredText;
          this.appendChild(label);
        }
      }
    }
  );
}
